// extracted by mini-css-extract-plugin
export default {"container":"hASazb","align-right":"cBZOv0","align-left":"KxFh3h","align-justify":"RP7aWP","bare":"gycJ_E","unit":"MmT0PO"};